import React from 'react'
import widgetsService from 'live/services/widgets'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import LithologyChart from './LithologyChart'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import lithology from './lithologyReducer'
import thumbnail from '../../../assets/img/lithology.png'
import { Fields, Separator, Title } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import Toogle from '../editor/fields/Toggle'
import ObjectSelector from '../editor/fields/ObjectSelector'
import AxesSizeConfig from '../../configurations/AxesSizeConfig'

const type = 'lithology2'

widgetsService.impl(
    type,
    widgetWrapper(LithologyChart, lithology, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) every 1000 items => @chain',
    handleOwnMissingData: true
})

widgetsService.queryHandlerKind(type, 'lithology')
widgetsService.properties(type, {})
widgetsService.config(type, {
    objectType: 'mudLog',
    verticalEnabled: false,
    span: 'ts 0 to ts 16000',
    numberOfVisibleAxes: 6,
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
})

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('Lithology'),
        description: i18n('Visualize well lithology per depth'),
        thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
            <ObjectSelector label={'Lithology'} objectType={'mudLog'} />
        </Fields>,
        <Fields>
            <Title>GLOBAL CHART OPTIONS</Title>

            <Toogle configField={'verticalEnabled'} label={i18n('Vertical chart')} />
            <Separator />
            <Title>Y AXIS OPTIONS</Title>
            <AxesSizeConfig configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')} />
        </Fields>
    ]
)
